<template>
  <div class="trends-explore-container">
    <div class="trends-main">
      <section class="tag-list">
        <el-tag
          class="tag-item"
          :key="tag"
          v-for="(tag, index) in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >
          <el-input
            class="change-input"
            v-if="changeVisible && currentIndex === index"
            v-model="changeValue"
            ref="changeTagInput"
            @keyup.enter.native="handleChangeConfirm(index)"
            @blur="handleChangeConfirm(index)"
          >
          </el-input>
          <span class="tag-name" v-else @dblclick="changeTag(tag, index)">{{
            tag
          }}</span>
        </el-tag>
        <el-input
          class="input-new-tag tag-item"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button
          v-else
          class="button-new-tag tag-item"
          size="small"
          @click="showInput"
          >+ New Keywords</el-button
        >
      </section>
      <section class="filter-list">
        <el-select v-model="dateFilterValue" placeholder="请选择">
          <el-option
            v-for="item in dateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </section>
      <section class="chart-container">
        <div id="main-chart"></div>
      </section>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      dateOptions: [
        {
          value: 0,
          label: "近20年（2001-2019)",
        },
        {
          value: 1,
          label: "近10年（2011-2019）",
        },
      ],
      dateFilterValue: 0,
        baseurl: "https://nsfc.acemap.info/",
      // baseurl: "http://10.10.10.225:8311/",
      changeVisible: false,
      changeValue: "",
      currentIndex: -1,
      myChart: null,
    };
  },
  mounted() {
    this.dynamicTags = [];
    this.keywords = this.$route.query.keyword;
    if (this.keywords) {
      this.dynamicTags.push(this.keywords);
    }
  },
  watch: {
    dynamicTags: {
      handler(nv) {
        if (nv.length) {
          this.getChartData();
        }
      },
      deep: true,
      immediate: true,
    },
    dateFilterValue() {
      if (this.dynamicTags.length) {
        this.getChartData();
      }
    },
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    changeTag(tag, index) {
      this.changeVisible = true;
      this.currentIndex = index;
      this.$nextTick((_) => {
        this.$refs.changeTagInput.$refs.input.focus();
        this.changeValue = tag;
      });
    },
    handleChangeConfirm(index) {
      if (this.changeValue) {
        this.$set(this.dynamicTags, index, this.changeValue);
      }
      this.changeVisible = false;
      this.changeValue = "";
      this.currentIndex = -1;
    },
    getChartData() {
      this.$axios
        .get(
          `${this.baseurl}api/v2/trends/keyword?keyword=${this.dynamicTags.join(
            ","
          )}&orderby=${this.dateFilterValue}`
        )
        .then((response) => {
          console.log("response", response);
          const data = response.data.data;
          if (data.length) {
            const chartData = this.handleChartData(data);
            this.initCharts(chartData);
          } else {
          }
        });
      //   this.initCharts(data);
    },
    handleChartData(data) {
      const trend = data[0].trend;
      const xAxis = trend.map((i) => i.year) || [];
      const seriesData = [];
      data.forEach((item) => {
        seriesData.push({
          name: item.keyword,
          type: "line",
          showSymbol: false,
          data: item.trend.map((i) => i.count),
        });
      });
      return {
        seriesData,
        xAxis,
      };
    },
    initCharts(data) {
      if (this.myChart) {
        this.myChart.clear();
      }
      const chartDom = document.getElementById("main-chart");
      this.myChart = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: data.xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: data.seriesData,
      };
      this.myChart.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
.trends-explore-container {
  background: #f0f2f5;
  padding: 10px;
  min-height: calc(100vh - 16px);
  .trends-main {
    // width: 1200px;
    width: 1400px;
    overflow: hidden;
    margin: 30px auto;
  }
  .tag-list {
    display: flex;
    .tag-item {
      flex: 1;
      height: 100px;
      line-height: 100px;
      border-radius: 16px;
      font-size: 20px;
    }
    .el-tag {
      background-color: #fff;
      border-color: #dcdfe6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-icon-close {
        font-size: 16px;
      }
    }
  }
  .filter-list {
    margin-top: 24px;
    background: #fff;
    padding: 24px 12px;
    border-radius: 20px;
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
#main-chart {
  width: 100%;
  height: 500px;
}
.chart-container {
  margin-top: 48px;
  background: #fff;
  padding: 24px;
  border-radius: 20px;
}
</style>
<style lang="less">
.trends-explore-container .tag-item {
  .el-input__inner {
    height: 100px;
    line-height: 100px;
  }
  .change-input {
    width: calc(100% - 34px);
    border: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Trends/explore.vue